<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalBusinessNature",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content: "<div class='fs4 fw7 lh125'>2. Nature of Business</div>"
					},
					bindTo: ""
				},
				{
					label: "Retail %",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderBusinessNatureRetailRatioId",
					props: {
						suggest: {
							typeIncludes: "businessNatureRetailRatio"
						},
						createOptions: {
							type: "businessNatureRetailRatio",
							dataType: "string"
						}
					}
				},
				{
					label: "Wholesale %",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderBusinessNatureWholesaleRatioId",
					props: {
						suggest: {
							typeIncludes: "businessNatureWholesaleRatio"
						},
						createOptions: {
							type: "businessNatureWholesaleRatio",
							dataType: "string"
						}
					}
				},
				{
					label: "Manufacture %",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderBusinessNatureManufactureRatioId",
					props: {
						suggest: {
							typeIncludes: "businessNatureManufactureRatio"
						},
						createOptions: {
							type: "businessNatureManufactureRatio",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
